module.exports = __webpack_public_path__ + "img/experience08.15ba5b9c.jpg";